import { jwtDecode } from "jwt-decode";
import {useEffect, useRef, useState} from 'react';
import {useAuth} from '../../auth/authContext'; // Stelle sicher, dass der AuthContext korrekt importiert ist
import axios from '../../api/axios'; // Deine Axios-Instanz
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faTimes} from '@fortawesome/free-solid-svg-icons';
import MadeByBRB from '../dashboard/MadeByBRB'; // Ein weiteres eigenes Modul

const LOGIN_URL = '/api/v1/login';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const LoginPage = () => {
    const {login, logout} = useAuth(); // Ergänze logout, um den Benutzer abzumelden
    const emailRef = useRef();
    const errRef = useRef();

    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(false);
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        emailRef.current.focus();
    }, []);

    useEffect(() => {
        setErrMsg('');
    }, [email, pwd]);

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(email));
    }, [email]);

    const setCookie = (name, value, days = 7) => {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value}; ${expires}; path=/; secure; samesite=None;`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            console.log('Sende Anmeldeanfrage an den Server...');
            const response = await axios.post(LOGIN_URL,
                JSON.stringify({email, password: pwd}),
                {
                    headers: {'Content-Type': 'application/json'},
                    withCredentials: true
                }
            );

            if (response.status === 200) {
                const accessToken = response.data.accessToken;
                const roles = response.data.roles;

                if (!accessToken) {
                    throw new Error('Kein Access Token erhalten');
                }

                // Token dekodieren, um authorities zu überprüfen
                const decodedToken = jwtDecode(accessToken);
                const authorities = decodedToken.authorities || [];
                const hasAdminAuthority = authorities.includes('hch.admin');

                // Wenn der Benutzer keine Berechtigungen hat, abmelden
                if (authorities.length === 0 || !hasAdminAuthority) {
                    setErrMsg('Keine ausreichenden Berechtigungen');
                    logout(); // Benutzer abmelden
                    return;
                }

                // Speichere den Access Token im Cookie
                setCookie('accessToken', accessToken);

                // Authentifizierungsdaten speichern
                login({email, roles, accessToken});

                setEmail('');
                setPwd('');
                setSuccess(true);
            } else {
                setErrMsg('Anmeldung fehlgeschlagen');
            }

        } catch (err) {
            console.error('Login-Fehler:', err);

            if (!err?.response) {
                setErrMsg('Keine Serverantwort');
            } else if (err.response?.status === 400) {
                setErrMsg('Fehlende E-Mail oder Passwort');
            } else if (err.response?.status === 401) {
                setErrMsg('Nicht autorisiert');
            } else {
                setErrMsg('Anmeldung fehlgeschlagen');
            }

            errRef.current.focus();
        }
    };

    return (
        <>
            {success ? (
                <section className="flex justify-center items-center h-screen">
                    <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                        <h1 className="text-2xl font-bold mb-4">Du bist eingeloggt!</h1>
                        <p>
                            <a href="/dashboard" className="text-blue-500 underline">Zur Startseite</a>
                        </p>
                    </div>
                </section>
            ) : (
                <section className="w-full h-screen flex flex-col justify-between">
                    <div className="flex justify-center items-center h-screen">
                        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                            <p ref={errRef} className={errMsg ? "errmsg text-red-500 mb-4" : "offscreen"}
                               aria-live="assertive">
                                {errMsg}
                            </p>
                            <h1 className="text-2xl font-bold mb-6 text-center">Anmelden</h1>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-4">
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                        E-Mail:
                                        <FontAwesomeIcon icon={faCheck}
                                                         className={validEmail ? "text-green-500 ml-2" : "hidden"}/>
                                        <FontAwesomeIcon icon={faTimes}
                                                         className={validEmail || !email ? "hidden" : "text-red-500 ml-2"}/>
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        ref={emailRef}
                                        autoComplete="off"
                                        onChange={(e) => setEmail(e.target.value)}
                                        value={email}
                                        required
                                        aria-invalid={validEmail ? "false" : "true"}
                                        className="mt-1 w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                    />
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                        Passwort:
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        onChange={(e) => setPwd(e.target.value)}
                                        value={pwd}
                                        required
                                        aria-invalid={pwd ? "false" : "true"}
                                        className="mt-1 w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                    />
                                </div>

                                <button
                                    className="w-full bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 focus:outline-none disabled:bg-gray-400"
                                    disabled={!validEmail || !pwd}
                                >
                                    Anmelden
                                </button>
                            </form>
                            <p className="hidden mt-4 text-center">
                                Noch kein Konto? <a href="/register"
                                                    className="text-blue-500 underline">Registrieren</a>
                            </p>
                        </div>
                    </div>
                    <div className='pb-4'>
                        <MadeByBRB/>
                    </div>
                </section>
            )}
        </>
    );
};

export default LoginPage;
